import React from 'react';

function Dashboard() {
  return (
   <div className="min-h-screen bg-dark flex items-center justify-center">
      <h1 className="text-white text-3xl font-bold">Dashboard - À venir</h1>
    </div>
  );
}

export default Dashboard;